// services/personal.service.ts
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Family } from '../store/family/family.state'
import { eps } from './url.service'

@Injectable({ providedIn: 'root' })
export class FamilyService {
  private apiUrl = eps.family.familyApi

  constructor(private http: HttpClient) {}

  getFamilies(
    params: string | null,
    page: number | null | undefined,
    limit: number | null | undefined
  ): Observable<{ families: Family[] }> {
    const url = params
      ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
      : `${this.apiUrl}?page=${page}&limit=${limit}`
    return this.http.get<{ families: Family[] }>(url)
  }

  createFamily(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}`, payload)
  }

  updateFamily(id: string, payload: any): Observable<Family> {
    return this.http.put<Family>(`${this.apiUrl}/${id}`, payload)
  }

  deleteFamily(familyId: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${familyId}`, {})
  }
}
